import { FC } from "react";
import { useAppSelector } from "../../../../../../../../../../../store/hooks";
import { TrendColumnHeaderCell } from "../../../../../../../../../resource-explorer/components/resource-explorer-card/components/resource-explorer-data-grid/components/columns/components/common/TrendColumnHeaderCell";
import { costBreakdownV2WidgetSetupTableTrendSelector } from "../../../../../../../../../../../store/dashboards/selectors/widgets/cost-breakdown-v2/setup/costBreakdownV2WidgetSetupTableTrendSelector";

export const CostBreakdownV2WidgetSetupTableTrendHeaderCell: FC = () => {
  const trend = useAppSelector(costBreakdownV2WidgetSetupTableTrendSelector);
  return <TrendColumnHeaderCell trend={trend} />;
};
